import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'A carregar {{label}}…',
  forbidden: 'Não tens permissão para ver {{label}}.',
  notFound: 'Não foi possível encontrar {{label}}.',
  loadingFailed: 'Falha ao carregar {{label}}: {{message}}',
  submitForbidden: 'Não tens permissão para fazer isto{{suffix}}',
  submitConflict: 'Isto entra em conflito com o estado atual{{suffix}}',
  submitGeneric: 'Algo correu mal: {{message}}',
};
